import {
  Mediator
} from 'application/src/js/util.js';

export default class ProductSelection extends Mediator {
  constructor(args) {
    super(args);
    this.container = document.querySelector('#product-selection');
    if (!this.container) return;
    this.selectedClass = 'selected';
    this.productButtons = [];

    this.init();
  }

  init() {
    [...this.container.querySelectorAll('.product-button')].map(button => {
      this.productButtons.push(new ProductButton({
        element: button,
        parent: this
      }));
    });
  }

  get selectedProductIds() {
    return this.productButtons.reduce((ids, button) => {
      if (button.isSelected) ids.push(button.id);
      return ids;
    }, []);
  }

  get selectedProducts() {
    return this.productButtons.reduce((products, button) => {
      if (button.isSelected) {
        products[button.id] = button.element.textContent.trim();
      }
      return products;
    }, {});
  }

  onProductSelectionChange(button) {
    if (!this.selectedProductIds.length) return false;

    if (button.isSelected) {
      button.element.classList.add(this.selectedClass);
      button.element.classList.remove('secondary');
    } else {
      button.element.classList.add('secondary');
      button.element.classList.remove(this.selectedClass);
    }

    this.publish('change', this.selectedProductIds, this.selectedProducts);
    return true;
  }
}

class ProductButton {
  constructor(args) {
    this.element = args.element;
    this.parent = args.parent;
    this.checkbox = this.element.querySelector('input');
    this.id = parseInt(this.checkbox.value);

    this.addEvents();
  }

  addEvents() {
    this.checkbox.addEventListener('change', e => {
      const validChange = this.parent.onProductSelectionChange(this);
      if (!validChange) e.target.checked = true;
    });
  }

  get isSelected() {
    return this.checkbox.checked === true;
  }
}